<template>
  <div class="home">
    <ul class="list">
      <li v-for="task in allTasks" :key="task.id">
        <TaskItem class="task"
          :info="task"/>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TaskItem from '@/components/TaskItem'

export default {
  name: 'home',
  components: {
    TaskItem
  },
  methods: {
    ...mapActions([
      'fetchTaskList'
    ])
  },
  computed: {
    ...mapGetters([
      'allTasks'
    ]),
    allTasksCount () {
      if (this.allTasks && this.allTasks.length > 0) {
        return this.allTasks.length
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.fetchTaskList()
  }
}
</script>

<style lang="scss" scoped>
.home {
  // background: yellow;

  .list {
    margin: 0 -4px -4px 0;

    list-style: none;
    padding: 0;

    display: flex;
    flex-wrap: wrap;
  }
  li {
    // height: 12.75rem;
    // border-right: 4px solid black;
    // border-bottom: 4px solid black;
    // background-color: deeppink;

    &:empty {
      height: 0;
      border: none;
    };
  }
  li,
  :before,
  :after {
    box-sizing: border-box;
  }
  padding: 2rem 1rem;
}
</style>
